import { Button, Form, Input, Switch } from 'antd';
import { useEffect } from 'react';
import type { AppSettings } from '@/types/settings';
import styles from '../Settings.module.scss';

interface PaymentGatewayTabProps {
  settings?: AppSettings;
  loading?: boolean;
  onSave: (values: AppSettings['payment']) => Promise<void>;
}

export function PaymentGatewayTab({ settings, loading, onSave }: PaymentGatewayTabProps) {
  const [form] = Form.useForm<AppSettings['payment']>();

  useEffect(() => {
    if (settings?.payment) {
      form.setFieldsValue({
        ...settings.payment,
        razorpayKeySecret: '',
      });
    }
  }, [form, settings?.payment]);

  return (
    <div>
      <h2 className={styles.sectionTitle}>Payment gateway settings</h2>
      <p className={styles.sectionDesc}>
        Enable payment methods and configure Razorpay credentials for online checkout.
      </p>

      <Form
        form={form}
        layout="vertical"
        disabled={loading}
        onFinish={onSave}
        requiredMark={false}
      >
        <div className={styles.switchRow}>
          <div className={styles.switchLabel}>
            <span className={styles.switchTitle}>Cash on Delivery (COD)</span>
            <span className={styles.switchHint}>Allow customers to pay when the order is delivered.</span>
          </div>
          <Form.Item name="codEnabled" valuePropName="checked" noStyle>
            <Switch />
          </Form.Item>
        </div>

        <div className={styles.switchRow}>
          <div className={styles.switchLabel}>
            <span className={styles.switchTitle}>Razorpay</span>
            <span className={styles.switchHint}>Accept online payments via Razorpay gateway.</span>
          </div>
          <Form.Item name="razorpayEnabled" valuePropName="checked" noStyle>
            <Switch />
          </Form.Item>
        </div>

        <div className={styles.formGrid}>
          <Form.Item label="Razorpay Key ID" name="razorpayKeyId">
            <Input placeholder="rzp_test_xxxxxxxx" />
          </Form.Item>

          <Form.Item label="Razorpay Key Secret" name="razorpayKeySecret">
            <Input.Password placeholder="Enter key secret" autoComplete="new-password" />
            {settings?.payment.hasRazorpayKeySecret ? (
              <p className={styles.secretHint}>Leave blank to keep the existing secret.</p>
            ) : null}
          </Form.Item>
        </div>

        <div className={styles.actions}>
          <Button type="primary" htmlType="submit" loading={loading}>
            Save changes
          </Button>
        </div>
      </Form>
    </div>
  );
}
